import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useStore } from 'vuex';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import layout from './views/layout';
import { v4 as uuidv4 } from 'uuid';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import { useRouter, useRoute } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { clearInvalidDataFromCart, parseAndOpenUrl } from '@/utils/common';
import constants, { encryptedMarketplaceId } from '@/constants';
import { isPrimaryPage } from '@/router/index';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import { isAppEnvIos } from '@/utils/device';
import { isShowPIPLConfirmAlertView } from '@/utils/common';
const __default__ = {
  name: 'IndexLayout'
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const {
      marketPlaceStyleMap,
      TABBAR_PAGE_APP_CODE,
      DOCUMENT_TITLE
    } = constants;
    const mainClass = ref('cn-app');
    // Handling special styles
    const initMainAppStyle = () => {
      mainClass.value = `${marketPlaceStyleMap[encryptedMarketplaceId]}-app`;
      useLess('views/App.less');
    };
    const router = useRouter();
    const route = useRoute();
    const {
      t
    } = useI18n();

    // Introducing the store library
    const store = useStore();
    // main content padding top
    const phoneContentTopHeight = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.phoneContentTopHeight) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    const isLoading = ref(false);
    const isCartMaxLimit = ref(false);

    // Display pop-up prompt when the number of shopping carts reaches the maximum limit
    watch(() => store.state.cart.isCartMaxLimit, value => {
      isCartMaxLimit.value = value;
    });
    // Close pop-up synchronization to change status
    watch(isCartMaxLimit, value => {
      store.commit('cart/setCartMaxLimitStatus', value);
    });
    const goToCart = () => {
      if (route.name === 'cart') {
        router.push({
          name: 'cart',
          query: {
            // Passing a uuid ensures that the value changes every time
            scrollToTop: uuidv4()
          }
        });
        store.commit('cart/setCartMaxLimitStatus', false);
        // Passing a uuid ensures that the value changes every time
        store.commit('cart/setCloseBuyingOptionsPopup', uuidv4());
        return;
      }
      Bridge.callFn('getWebViewOriginalPagePath', {}, ({
        path
      }) => {
        router.push(path);
      });
      Bridge.callFn('changeTabbarSelectItem', {
        selectIndex: TABBAR_PAGE_APP_CODE.CART
      }, () => {});
    };
    const onOneClickCartCleaning = () => {
      isLoading.value = true;
      clearInvalidDataFromCart(data => {
        isLoading.value = false;
        if (data.status) {
          showToast({
            message: `${data.count}${t('modules.cart.INELIGIBLE_PRODUCT_CLEAR_SUCCESSFUL')}`,
            className: 'a-toast'
          });
          store.commit('cart/setCurrentCartRefreshStatus', true);
        } else {
          store.commit('cart/setCartMaxLimitStatus', true);
          showToast({
            message: t('modules.cart.NO_SPACE_TO_CLEAR'),
            className: 'a-toast'
          });
        }
      });
    };
    onMounted(async () => {
      document.title = DOCUMENT_TITLE;
      store.commit(`navigator/${SET_AGENT_DATA}`);
      store.commit('common/setPIPLAuthorizedStatus', !(await isShowPIPLConfirmAlertView(false)));
      if (isAppEnvIos()) {
        /**
         * controlWebViewBounces
         * Control the drag and drop effects of bounces on the current webview, IOS only
         * Gswebapp turns off this effect, amz wants this effect
         */
        Bridge.callFn('controlWebViewBounces', {
          enable: false
        }, async () => {});
        Bridge.callFn('getAppTabbarHeight', {}, async result => {
          store.commit(`common/getTabbarHeight`, result.height);
        });
      }
      window.onpageshow = () => {
        const path = router.currentRoute.value;
        if (!path.name) return;
        const isPrimaryPageVal = isPrimaryPage(path);
        Bridge.callFn('bottomBarStatusChange', {
          show: isPrimaryPageVal
        });
      };
      Bridge.registerFn('onOpenUrlProvidedByNative', res => {
        const url = res.url;
        parseAndOpenUrl(router, url);
      });
    });
    initMainAppStyle();
    return (_ctx, _cache) => {
      const _component_pop_up = _resolveComponent("pop-up");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        id: "app",
        class: _normalizeClass(["main-app", [mainClass.value]]),
        style: _normalizeStyle({
          'padding-top': phoneContentTopHeight.value + 'px'
        })
      }, [_withDirectives(_createVNode(_unref(layout), null, null, 512), [[_directive_loading, isLoading.value]])], 6), _createVNode(_component_pop_up, {
        class: "cart-max-limit-pop-up",
        show: isCartMaxLimit.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isCartMaxLimit.value = $event),
        title: _unref(t)('modules.cart.SHOPPING_CART_FULL_PROMPT'),
        btnConfirmText: _unref(t)('modules.cart.ONE_CLICK_CLEAR'),
        btnCancelShow: true,
        isOverCartMaxLimit: true,
        btnCancelText: _unref(t)('modules.cart.GO_TO_CART'),
        onClose: goToCart,
        onConfirm: onOneClickCartCleaning
      }, null, 8, ["show", "title", "btnConfirmText", "btnCancelText"])], 64);
    };
  }
});